// import courseService from 'ApiService/Admin/courseService';
// import jobServices from 'ApiService/Admin/jobServices';
// import studentService from 'ApiService/Admin/studentService';
// import Card from 'components/card';
// import { AuthContext } from 'contexts/AuthContext';
// import { useContext, useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
// import SelectClass from './Class/Index';
// import AttendancesSheet from './Sheet/Index';

// const MarkAttendance = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [classData, setClassData] = useState({
//     courseId: '',
//     batchId: '',
//   });
//   const [attendance, setAttendance] = useState([]);
//   const [disable, setDisable] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [courses, setCourses] = useState([]);
//   const [loadingCourses, setLoadingCourses] = useState(true);
//   const { state } = useContext(AuthContext);
//   const selectedBranch = state?.selectedBranch || '';
//   const steps = [
//     { stepNo: 1, name: 'Class Info' },
//     { stepNo: 2, name: 'Add Details' },
//   ];

//   const fetchCourses = async () => {
//     setCourses([]);
//     setLoadingCourses(true);
//     try {
//       const response = await courseService.getCourseBatchInfo(selectedBranch);
//       if (response.data.success) {
//         setCourses(response.data.courses || []);
//       } else {
//         toast.error('Failed to fetch courses.');
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
//     } finally {
//       setLoadingCourses(false);
//     }
//   };

//   async function getStudents() {
//     try {
//       const selectedBranch = state.selectedBranch || '';
//       const response = await studentService.getStudentsDetails(
//         classData.courseId,
//         classData.batchId,
//         selectedBranch
//       );
//       if (response.data.success) {
//         const students = response?.data?.data;
//         if (students.length === 0) {
//           // No students found
//           setAttendance([]);
//           toast.info('No students found in this class.');
//         } else {
//           // Set the attendance state with student data
//           setAttendance(
//             students.map((student) => ({
//               id: student._id,
//               ready: true,
//               name: student.name,
//               placementPriority: 'Medium',
//             }))
//           );
//         }
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message ||
//           'An error occurred while fetching students.'
//       );
//     }
//   }

//   useEffect(() => {
//     fetchCourses();
//   }, [state, state?.selectedBranch]);

//   const clearAttendance = () => {
//     setAttendance([]);
//   };

//   const handleStudentPause = async (pauseDetails) => {
//     try {
//       const response = await jobServices.pauseStudentPlacement(pauseDetails);
//       if (response.data.success) {
//         // Update student status or perform any necessary actions
//         return { success: true };
//       } else {
//         return {
//           success: false,
//           message: response.data.message || 'Failed to pause placement',
//         };
//       }
//     } catch (error) {
//       return {
//         success: false,
//         message: 'Error pausing placement',
//       };
//     }
//   };

//   const displayStep = (step) => {
//     switch (step.stepNo) {
//       case 1:
//         return (
//           <SelectClass
//             setLoading={setLoading}
//             setDisable={setDisable}
//             setClassData={setClassData}
//             classData={classData}
//             courses={courses}
//             loadingCourses={loadingCourses}
//             clearAttendance={clearAttendance}
//             currentStep={currentStep}
//             disable={disable}
//             handleNext={handleNext}
//             handleBack={handleBack}
//           />
//         );
//       case 2:
//         return (
//           <AttendancesSheet
//             getStudents={getStudents}
//             setLoading={setLoading}
//             setDisable={setDisable}
//             classData={classData}
//             setClassData={setClassData}
//             attendance={attendance}
//             onStudentPause={handleStudentPause}
//             setAttendance={setAttendance}
//             currentStep={currentStep}
//             disable={disable}
//             handleNext={handleNext}
//             handleBack={handleBack}
//           />
//         );
//       default:
//     }
//   };

//   const handleNext = async () => {
//     if (disable) return;
//     setLoading(true);
//     setCurrentStep(currentStep + 1);
//     setLoading(false);
//   };

//   const handleBack = () => {
//     if (disable) return;
//     setCurrentStep((cs) => cs - 1);
//   };

//   const handleKeyDown = (event) => {
//     if (disable) return;

//     if (event.key === 'Enter') {
//       if (currentStep === 1) {
//         handleNext();
//       }
//     } else if (event.key === 'ArrowLeft') {
//       if (currentStep > 1) {
//         handleBack();
//       }
//     } else if (event.key === 'ArrowRight') {
//       if (currentStep < steps.length) {
//         handleNext();
//       }
//     }
//   };

//   useEffect(() => {
//     window.addEventListener('keydown', handleKeyDown);
//     return () => {
//       window.removeEventListener('keydown', handleKeyDown);
//     };
//   }, [currentStep, disable]);

//   return (
//     <div className="mt-10 h-full w-full md:mt-10">
//       <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px] " />
//       <div
//         className={`w-md:2/3 mx-auto h-full ${
//           currentStep === 1 ? 'w-6/6' : 'w-6/6'
//         } md:px-8  3xl:w-7/12`}
//       >
//         <Card extra={'-mt-[280px] w-full md:-mt-[340px]  h-full mx-auto pb-3'}>
//           <div className="w-full rounded-[20px]">
//             <UseContextProvider>
//               {displayStep(steps[currentStep - 1])}
//             </UseContextProvider>
//           </div>
//         </Card>
//       </div>
//     </div>
//   );
// };

// export default MarkAttendance;

import courseService from 'ApiService/Admin/courseService';
import studentService from 'ApiService/Admin/studentService';
import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
import SelectClass from './Class/Index';
import AttendancesSheet from './Sheet/Index';
import batchService from 'ApiService/Admin/batchService';

const MarkAttendance = () => {
  const [currentStep, setCurrentStep] = useState(1);

  const [classData, setClassData] = useState({
    courseId: '',
    batchStructureId: '',
    batchId: '',
  });

  const [attendance, setAttendance] = useState([]);
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);

  const [courses, setCourses] = useState([]);
  const [batchStructures, setBatchStructures] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(true);

  const { state } = useContext(AuthContext);
  const user = state?.user;
  const role = user?.role;
  const isSuperAdmin = role === 'superadmin';

  const selectedBranch = isSuperAdmin
    ? state?.selectedBranch
    : user?.branch?._id;

  const steps = [
    { stepNo: 1, name: 'Class Info' },
    { stepNo: 2, name: 'Add Details' },
  ];

  /* ================= FETCH COURSES ================= */
  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      const res = await courseService.getAllCourses(selectedBranch);
      if (res.data.success) {
        setCourses(res.data.courses || []);
      }
    } catch {
      toast.error('Failed to fetch courses');
    } finally {
      setLoadingCourses(false);
    }
  };

  /* ================= FETCH STRUCTURES ================= */
  const fetchBatchStructures = async (courseId) => {
    try {
      const res = await batchService.getBatchStructuresByCourse(
        courseId,
        selectedBranch
      );
      setBatchStructures(res?.data?.batchStructures || []);
    } catch {
      toast.error('Failed to fetch batch structures');
      setBatchStructures([]);
    }
  };

  /* ================= FETCH BATCHES ================= */
  const fetchBatchesByStructure = async (structureId) => {
    try {
      const res = await batchService.getBatchesByBatchStructure(
        structureId,
        selectedBranch
      );
      return res?.data?.batches || [];
    } catch {
      toast.error('Failed to fetch batches');
      return [];
    }
  };

  /* ================= FETCH STUDENTS ================= */
  const getStudents = async () => {
    try {
      const res = await studentService.getStudentsDetails(
        classData.courseId,
        classData.batchId,
        selectedBranch
      );

      if (res.data.success) {
        const students = res.data.data || [];
        setAttendance(
          students.map((s) => ({
            id: s._id,
            ready: true,
            name: s.name,
            placementPriority: 'Medium',
          }))
        );
      }
    } catch {
      toast.error('Failed to fetch students');
    }
  };

  useEffect(() => {
    fetchCourses();
  }, [selectedBranch]);

  const clearAttendance = () => {
    setAttendance([]);
  };

  const handleNext = async () => {
    if (currentStep === 1) {
      await getStudents();
      setCurrentStep(2);
    }
  };

  const handleBack = () => {
    setCurrentStep(1);
  };

  const displayStep = (step) => {
    switch (step.stepNo) {
      case 1:
        return (
          <SelectClass
            setDisable={setDisable}
            setLoading={setLoading}
            classData={classData}
            setClassData={setClassData}
            courses={courses}
            batchStructures={batchStructures}
            fetchBatchStructures={fetchBatchStructures}
            fetchBatchesByStructure={fetchBatchesByStructure}
            loadingCourses={loadingCourses}
            clearAttendance={clearAttendance}
            currentStep={currentStep}
            disable={disable}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        );

      case 2:
        return (
          <AttendancesSheet
            attendance={attendance}
            setAttendance={setAttendance}
            currentStep={currentStep}
            disable={disable}
            handleBack={handleBack}
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="mt-10 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />

      <div className="w-6/6 mx-auto h-full md:px-8 3xl:w-7/12">
        <Card extra="-mt-[280px] w-full md:-mt-[340px] pb-3">
          <UseContextProvider>
            {displayStep(steps[currentStep - 1])}
          </UseContextProvider>
        </Card>
      </div>
    </div>
  );
};

export default MarkAttendance;
